import React from "react";
import * as comp from "../lib/tiles/tiles";
import { LAYOUT } from "../lib/types/scoutingSheetConfigTypes";
import {events, layouts} from "../scouting-sheet-config";

import { COMPETITION } from "../lib/types/scoutingSheetConfigTypes";
import { PageGenerator } from "../lib/tiles/pageGenerator";

import { Context as scoutSessionContext } from "../lib/providers/scoutSessionProvider";
import { Context as dataContext } from "../lib/providers/dataProvider";

const ScoutingSheet = () => {
    const { setSession } = React.useContext(scoutSessionContext);
    const { resetData } = React.useContext(dataContext);
    const [event, _setEvent] = React.useState<COMPETITION>(events.find((event) => event.name === localStorage.getItem("event") || "") || {name: "", teams: []});
    const [teamNumber, setTeamNumber] = React.useState<number>(0);
    const [matchNumber, setMatchNumber] = React.useState<number>(0);
    const [sheetNum, setSheetNum] = React.useState<number>(0); //SET TO 0 IN PRODUCTION
    const [tempType, setTempType] = React.useState<string>("");
    const [layout, _setLayout] = React.useState<LAYOUT>({} as LAYOUT);

    const eventsList: string[] = events.map((event) => event.name);
    const layoutList: string[] = layouts.map((layout) => layout.name);

    const setEvent = (value: string) => {
        events.forEach((event) => {
            if (event.name === value) {
                _setEvent(event);
                localStorage.setItem("event", event.name);
            }
        });
    }

    const setLayout = (value: string) => {
        layouts.forEach((layout) => {
            if (layout.name === value) {
                _setLayout(layout);
                setTempType(layout.type);
            }
        });
    }

    const Start = () => {
        setSession(tempType, teamNumber.toString(), tempType === "match" ? matchNumber.toString() : "");
        resetData();
        setSheetNum(1);
    }
    
    if (sheetNum === 0) {
        return (
            <div>
                <div className="text-center mt-2">
                    Chill Out 1778 Scouting
                </div>
                <comp.Row alignment="center">
                    <div>
                        <comp.OverlaySelection height="15vh" width="50vw" label="Select Event" defaultState={event.name} backgroundColor="blue" buttonColor="blue" choices={eventsList} onChange={setEvent} />
                        {event.name !== "" ? <comp.OverlaySelection height="15vh" width="50vw" label="Select Scouting Type" backgroundColor="blue" buttonColor="blue" choices={layoutList} onChange={setLayout} /> : null }
                        {tempType !== "" ? <comp.TextEntry height="15vh" width="50vw" label="Team Number" placeholder={"Enter Team Number Here"} onChange={setTeamNumber} numberOnly={true}/> : null}
                        {tempType === "match" ? <comp.TextEntry height="15vh" width="50vw" label="Match Number" placeholder={"Enter Match Number Here"} onChange={setMatchNumber} numberOnly={true}/> : null}
                        {event.teams.includes(Number(teamNumber)) && matchNumber !== 0 ? <comp.Button height="15vh" width="50vw" color="blue" label="Start" onChange={Start}/> : null}
                        {event.teams.includes(Number(teamNumber)) && tempType !== "match" ? <comp.Button height="15vh" width="50vw" color="blue" label="Start" onChange={Start}/> : null}
                        </div>
                </comp.Row>
            </div>
        );
    }
    
    return (
        <div>
            <div style={{height: "10vh", display: "flex", justifyContent: "right", alignItems: "center"}}>
                <div className="h-full pr-8 text-xl text-right">
                    {"Team: " + teamNumber}
                </div>
                <div className="h-full pr-2 text-xl text-right">
                    {matchNumber === 0 ? "Pit Scouting" : "Match: " + matchNumber}
                </div>
            </div>
            <PageGenerator layouts={layout} />
        </div>
    );
}

export default ScoutingSheet;